import React from 'react'

export default function Reward({reward}) {
    return (
        <li>
            <span>{reward}</span>
        </li>
    )
}
